import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../shared/auth'
import { Loader2 } from 'lucide-react'

const MobileProtectedRoute = ({ children }) => {
  // 認証状態の取得
  const { isAuthenticated, isLoading } = useAuth()

  // ローディング中の表示
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
          <p className="text-gray-600">認証中...</p>
        </div>
      </div>
    )
  }

  // 未認証の場合はログイン画面にリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/appLogin" replace />
  }

  // 認証済みの場合は子コンポーネントを表示
  return children
}

export default MobileProtectedRoute